import { render, staticRenderFns } from "./ButtonDashed.vue?vue&type=template&id=5832f8be"
import script from "./ButtonDashed.vue?vue&type=script&lang=ts"
export * from "./ButtonDashed.vue?vue&type=script&lang=ts"
import style0 from "./ButtonDashed.vue?vue&type=style&index=0&id=5832f8be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports